import { ThemeTokens, VARIANTS } from '../../types';
import {
    ACCESSIBLE_BRAND_ORANGE,
    BLACK,
    BRAND_PURPLE,
    styles as coreStyles,
    TRANSPARENT,
    WHITE,
} from './core-theme';

const SMART_GREEN = '#044F60';
const SMART_GRAY_GREEN = '#CDDFD6';
const SMART_YELLOW_GREEN = '#EFEDAB';

const styles: Record<VARIANTS, Record<ThemeTokens, any>> = {
    ...coreStyles,
    mood_01: {
        background: {
            background: SMART_GRAY_GREEN,
        },
        'overlay-gradient': {
            color: WHITE,
            background: SMART_GRAY_GREEN,
        },
        ctaLink: {
            border: SMART_GREEN,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: SMART_GREEN,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: SMART_GREEN,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: SMART_GREEN,
            },
            focus: {
                background: SMART_GREEN,
            },
            active: {
                background: SMART_GREEN,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
    mood_02: {
        background: {
            background: SMART_GREEN,
        },
        'overlay-gradient': {
            color: BLACK,
            background: SMART_GREEN,
        },
        ctaLink: {
            border: SMART_YELLOW_GREEN,
            color: WHITE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: WHITE,
            underline: SMART_YELLOW_GREEN,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: SMART_YELLOW_GREEN,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: SMART_YELLOW_GREEN,
            },
            focus: {
                background: SMART_YELLOW_GREEN,
            },
            active: {
                background: SMART_YELLOW_GREEN,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${WHITE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
    mood_03: {
        background: {
            background: SMART_YELLOW_GREEN,
        },
        'overlay-gradient': {
            color: WHITE,
            background: SMART_YELLOW_GREEN,
        },
        ctaLink: {
            border: SMART_GREEN,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: SMART_GREEN,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: SMART_GREEN,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: SMART_GREEN,
            },
            focus: {
                background: SMART_GREEN,
            },
            active: {
                background: SMART_GREEN,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
};

export const getThemeTokens = (token: ThemeTokens, variant: VARIANTS) => {
    return styles[variant][token];
};
